import request from '@/router/axios'

export const getTopicList = (current, size, params, deptId) => request({
  url: '/api/mcc-base/basetopic/topicList1',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const submitTopic = params => request({
  url: '/api/mcc-base/basetopic/save',
  method: 'post',
  data: params,
})

export const getCommentList = (current, size, params, deptId) => request({
  url: '/api/mcc-base/basefeedback/getFeedBack',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const submitComment = params => request({
  url: '/api/mcc-base/basefeedback/save',
  method: 'post',
  data: params,
})

export const updateResolve = params => request({
  url: '/api/mcc-base/basetopic/update',
  method: 'post',
  data: params,
})

export default {
  getTopicList,
}
